import { trim } from 'lodash';
import { TFile } from 'types/file';
import { TPicture as TPictureNewVariant } from 'types/picture';

import { GlobalConstants } from '@constants/global';

type baseVariant = string;

type TPictureOldVariant = {
    src: string;
};

type TPicture = baseVariant | TPictureOldVariant | TPictureNewVariant;

interface IImagePicker {
    picture: TPicture | TFile;
    size?: 'compressed' | 'original';
    noImageUrl?: string;
}

export const imagePicker = ({
    picture,
    size = 'compressed',
    noImageUrl = GlobalConstants.NoImageUrl,
}: IImagePicker): string => {
    const { BaseUrlForImg: basePath } = GlobalConstants;

    if (picture) {
        if (picture?.constructor === File) {
            return URL.createObjectURL(picture);
        }
        const imgName =
            (picture as TPictureNewVariant)[size] ||
            (picture as TPictureOldVariant).src ||
            (picture as baseVariant)

        if ((imgName as string)?.length) {
            return `${basePath}/${trim(imgName, '/')}`;
        }
    }

    return `${basePath}${noImageUrl}`;
};
